import './App.css';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import React from 'react';
import { BrowserRouter } from "react-router-dom";
import LeidenfrostTheme from './theme/LeidenfrostTheme';
import Routes from "./routes/Routes";
import { AuthContextProvider } from 'providers/AuthContextProvider';
import { SdkContextProvider } from 'providers/OperationalContextProvider';
import { CssBaseline } from '@mui/material';
const defaultTheme = createTheme({});

function ToggleCustomTheme({ showCustomTheme, toggleCustomTheme }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100dvw',
        position: 'fixed',
        bottom: 24,
      }}
    >
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={showCustomTheme}
        onChange={toggleCustomTheme}
        aria-label="Platform"
        sx={{
          backgroundColor: 'background.default',
          '& .Mui-selected': {
            pointerEvents: 'none',
          },
        }}
      >
        <ToggleButton value>
          <AutoAwesomeRoundedIcon sx={{ fontSize: '20px', mr: 1 }} />
          Custom theme
        </ToggleButton>
        <ToggleButton value={false}>Material Design 2</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

ToggleCustomTheme.propTypes = {
  showCustomTheme: PropTypes.shape({
    valueOf: PropTypes.func.isRequired,
  }).isRequired,
  toggleCustomTheme: PropTypes.func.isRequired,
};

function App() {

  const [mode, setMode] = React.useState('dark');
  const LPtheme = createTheme(LeidenfrostTheme(mode));

  return (
    <ThemeProvider theme={true ? LPtheme : defaultTheme}>
      <CssBaseline />
      <AuthContextProvider>
        <SdkContextProvider>
          <BrowserRouter>
          <Routes />
          </BrowserRouter>
        </SdkContextProvider>
      </AuthContextProvider>
    </ThemeProvider>
  );
}

export default App;
